import { createContext, useContext, useState, useEffect } from 'react';
import { authHeaders } from './api';

const CurrencyContext = createContext();

export function CurrencyProvider({ children }) {
  const [displayCurrency, setDisplayCurrency] = useState(() => {
    return localStorage.getItem('displayCurrency') || 'USD';
  });
  const [exchangeRate, setExchangeRate] = useState({ cad_to_usd: 0.7353, usd_to_cad: 1.36 });
  const [rateLoaded, setRateLoaded] = useState(false);

  useEffect(() => {
    async function fetchRate() {
      try {
        const res = await fetch('/api/exchange-rate', { headers: authHeaders() });
        if (res.ok) {
          const data = await res.json();
          setExchangeRate(data);
        }
      } catch {}
      setRateLoaded(true);
    }
    fetchRate();
  }, []);

  useEffect(() => {
    localStorage.setItem('displayCurrency', displayCurrency);
  }, [displayCurrency]);

  const toggleCurrency = () => {
    setDisplayCurrency(prev => prev === 'USD' ? 'CAD' : 'USD');
  };

  const convert = (amount, fromCurrency) => {
    if (!amount || amount === 0) return 0;
    const from = (fromCurrency || 'USD').toUpperCase();
    const to = displayCurrency;
    if (from === to) return amount;
    if (from === 'CAD' && to === 'USD') return amount * exchangeRate.cad_to_usd;
    if (from === 'USD' && to === 'CAD') return amount * exchangeRate.usd_to_cad;
    return amount;
  };

  const convertToAlt = (amount, fromCurrency) => {
    if (!amount || amount === 0) return 0;
    const from = (fromCurrency || 'USD').toUpperCase();
    const altCurrency = displayCurrency === 'USD' ? 'CAD' : 'USD';
    if (from === altCurrency) return amount;
    if (from === 'CAD' && altCurrency === 'USD') return amount * exchangeRate.cad_to_usd;
    if (from === 'USD' && altCurrency === 'CAD') return amount * exchangeRate.usd_to_cad;
    return amount;
  };

  const altCurrency = displayCurrency === 'USD' ? 'CAD' : 'USD';

  return (
    <CurrencyContext.Provider value={{
      displayCurrency,
      altCurrency,
      exchangeRate,
      rateLoaded,
      toggleCurrency,
      convert,
      convertToAlt,
    }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
